import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import HintCSCard from './HintCSCard';
import HintJPSCard from './HintJPSCard';

export const HintCSList = ({
  data, onInvite, onToggle, onRemove, previewURL, onReminder, jobId, currentAccount,
}) => {
  if (ArrayUtil.isEmpty(data)) return null;

  return (
    <div className="box-body">
      <div className="cardList cardList--table">
        {ArrayUtil.sortCSRespondentAlphabet(data).map((item, index) => (
          <Fragment key={item.id}>
            <HintCSCard
              item={item}
              key={item.id}
              onInvite={onInvite}
              onToggle={onToggle}
              onRemove={onRemove}
              previewURL={previewURL}
              onReminder={onReminder}
              jobId={jobId}
              currentAccount={currentAccount}
            />
            {index !== data.length - 1 && (<hr />)}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

HintCSList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any),
  onInvite: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onReminder: PropTypes.func.isRequired,
  previewURL: PropTypes.string,
  jobId: PropTypes.string.isRequired,
  currentAccount: PropTypes.string.isRequired,
};

HintCSList.defaultProps = {
  data: [],
  previewURL: '',
};

export const HintJPSList = ({
  data, onInvite, onToggle, onRemove, previewURL, onReminder, jobId, nameJobProfile,
}) => {
  if (ArrayUtil.isEmpty(data)) return null;

  return (
    <div className="box-body">
      <div className="cardList cardList--table">
        {ArrayUtil.sortCSRespondentAlphabet(data).map((item, index) => (
          <Fragment key={item.id}>
            <HintJPSCard
              item={item}
              key={item.id}
              onInvite={onInvite}
              onReminder={onReminder}
              onToggle={onToggle}
              onRemove={onRemove}
              previewURL={previewURL}
              jobId={jobId}
              nameJobProfile={nameJobProfile}
            />
            {index !== data.length - 1 && (<hr />)}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

HintJPSList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any),
  onInvite: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onReminder: PropTypes.func.isRequired,
  previewURL: PropTypes.string,
  jobId: PropTypes.string.isRequired,
  nameJobProfile: PropTypes.string.isRequired,
};

HintJPSList.defaultProps = {
  data: [],
  previewURL: '',
};
